const defaultState = [];

export default defaultState;
